
const NotesStyle = theme => ({
    notesWrapper: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        overflow: "auto",
        position: "relative"
    },
    tableHeader: {
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        flex: 1,
        minHeight: 35,
        maxHeight: 35,
        backgroundColor: "#eaeded"
    },
    emptyRow: {
        paddingTop: 14,
        paddingLeft: 43,
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "18px",
        letterSpacing: 0,
        lineHeight: "22px",
        display: "flex",
        minHeight: 100
    },
    dateSection: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        width: 170,
        padding: "0px 20px"
    },
    notesSection: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        display: "flex",
        flex: 1,
        paddingRight: "20px"
    },
    NotesRowWrapper: {
        borderBottom: "2px solid #ededed",
        display: "flex",
        paddingTop: 6.5,
        flexShrink:0,
        paddingBottom: 6.5,
        backgroundColor: "#ffffff"
    },
    NotesOddRowWrapper: {
        borderBottom: "2px solid #ededed",
        display: "flex",
        paddingTop: 6.5,
        paddingBottom: 6.5,
        flexShrink:0,
        backgroundColor: "#fafafa"
    },
    dateRowStyle: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        paddingLeft: 20,
        lineHeight: "17px",
        width: 170,
    },
    noteRowStyle: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "17px",
        display: "flex",
        flex: 1,
        whiteSpace: "pre-wrap",
        paddingRight: 20
    },
    stickyHeader: {
        position: "sticky",
        zIndex: 1
    }
})

export default NotesStyle;
